import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  cta?: ReactNode;
}

// Reusable empty state. Hebrew copy template: "אין X. הוסף Y כדי להתחיל."
// See guidelines 05-arbox-ui-design-system.md §13.
export function EmptyState({ icon, title, description, cta }: EmptyStateProps) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center py-16 px-4">
      {icon && <div className="text-secondary-text mb-4">{icon}</div>}
      <div className="text-heading-3-bold text-main-text mb-1">{title}</div>
      {description && <div className="text-small text-secondary-text max-w-md">{description}</div>}
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
